// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/soc-frontend/" + chunkId + "." + {"4":"01050f0c","81":"ee202a8a","223":"1562db5f","325":"b9503cc2","682":"34c66292","905":"004541b1","967":"a9758ab4"}[chunkId] + ".chunk.js";
};